// @mui
import {
  Typography,
  Box,
  Stack,
  Button,
  CircularProgress,
  Popover,
  Chip,
  Grid,
  TextField,
  // RadioGroup,
  // FormControlLabel,
  // Radio,
  Container,
  IconButton,
  Divider,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';

import { useMemo, useState } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ArrowBack } from '@mui/icons-material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { mockSlots } from '../../mock/slotsData';
import { activeSnack } from '../../server/store/common';
import { useDevice } from '../../hooks/useResponsive';
import { colors } from '../../theme/colors';

BookingPage.propTypes = {};

export default function BookingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const slotList = { response: mockSlots };
  const [submitting, setSubmitting] = useState(false);
  const loading = submitting;

  const [selectedDate, setSelectedDate] = useState(moment().add(1, 'day'));
  const [sessionValue, setSessionValue] = useState('');
  const [selectedTimeLabel, setSelectedTimeLabel] = useState('');

  const { isMobile } = useDevice();

  const today = moment(selectedDate).format('yyyy-MM-DD');
  const oneWeek = moment().add(6, 'days');

  const dayName = moment(selectedDate).format('ddd');
  const currentDate = moment(selectedDate).format('D-MMM');

  const filteredSessions = slotList?.response?.filter((item) => item?.date === today);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      phone: '',
      email: '',
      address: '',
    },
  });

  const onSubmit = async (value, e) => {
    e?.preventDefault();
    setSubmitting(true);
    try {
      const payload = {
        name: value.name,
        email: value.email,
        phone: value.phone,
        address: value.address,
        booking_date: moment(selectedDate).format('YYYY-MM-DD'),
        booking_time: selectedTimeLabel || sessionValue || 'Not Selected',
      };

      const response = await fetch('/api/booking.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const resData = await response.json();

      if (response.ok && resData.status === 'success') {
        dispatch(
          activeSnack({
            type: 'success',
            message: resData.message || 'Booked successfully! Our expert will visit you soon.',
          })
        );
        reset();
        setSessionValue('');
        setSelectedTimeLabel('');
      } else {
        dispatch(
          activeSnack({
            type: 'error',
            message: resData.message || 'Failed to submit booking. Please try again.',
          })
        );
      }
    } catch (err) {
      dispatch(
        activeSnack({
          type: 'error',
          message: 'Network error. Please try again later.',
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const CustomButton = styled(Button)({
    background: colors.primary,
    color: 'white',
    borderRadius: '0',
    boxShadow: 'none',
    fontSize: '23px',
    fontWeight: '900',
    '&:hover': {
      background: colors.primary,
      color: 'white',
    },
  });

  const todayDate = moment().startOf('day').add(1, 'day');
  const dates = useMemo(
    () => Array.from({ length: 5 }, (_, i) => todayDate.clone().add(i, 'days')),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [todayDate.format('YYYY-MM-DD')]
  );

  const [anchorEl, setAnchorEl] = useState(null);

  const handleCalendarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);

  // const methods = [
  //   { label: '100% upfront', value: '100% upfront', miniText: '' },
  //   {
  //     label: '50% upfront (advance)',
  //     value: '50% upfront (advance)',
  //     miniText: 'Balance after successful completion.',
  //   },
  //   { label: '3 monthly instalments', value: '3 monthly instalments', miniText: 'No hidden charges.' },
  // ];
  // console.log('errors', errors);
  return (
    <Box sx={{ background: 'linear-gradient(90deg, #F24848 0%, #F8885F 100%)' }}>
      <Container
        sx={{
          // p: '19rem 21rem 24px',
          paddingTop: '19rem',
          pb: '24px',
          pl: '8rem !important',
          pr: '8rem !important',
          marginTop: '-17rem',
          // background: 'linear-gradient(90deg, #F24848 0%, #F8885F 100%)',
        }}
      >
        <Box>
          <Typography
            className="merri-weather-text-bold"
            // variant="h3"
            sx={{
              // fontFamily: 'Merriweather Sans',
              fontSize: '28px',
              lineHeight: 1,
              letterSpacing: '0%',
              color: '#fff',
            }}
          >
            Schedule Home Visit
          </Typography>
          <Stack
            sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center', py: '1rem' }}
            onClick={() => navigate(-1)}
          >
            <IconButton sx={{ ml: '-11px' }}>
              <ArrowBack sx={{ color: 'white', cursor: 'pointer', fontSize: '20px' }} />
            </IconButton>
            <Typography className="roboto-sans-regular" fontWeight={600} fontSize="16px" color="white">
              Back
            </Typography>
          </Stack>
        </Box>
        <Stack sx={{ padding: '64px', borderRadius: '24px', maxWidth: 'max-content', backgroundColor: '#fff' }}>
          <Box sx={{ '& > *:not(:first-of-type)': { mt: 2 } }}>
            <Box
              component="img"
              src="/assets/images/Booking/bookingWeb.webp"
              alt="Banner"
              sx={{
                width: '100%',
                // borderRadius: '11.56px',
                mb: 2,
              }}
            />
          </Box>
          <Typography variant="subtitle1" className="roboto-sans-medium" fontWeight={500} fontSize="20px" mb={1}>
            Choose a Time Slot
          </Typography>

          {/* Time Slots */}
          <Stack direction="row" justifyContent="space-between" pb="2px">
            <Grid container spacing={1.5}>
              {dates.map((date, i) => {
                const isSelected = selectedDate && date.isSame(selectedDate, 'day');

                return (
                  <Grid item key={i} sm={4} md={2.4}>
                    <Button
                      onClick={() => {
                        setSelectedDate(date);
                      }}
                      variant={isSelected ? 'contained' : 'outlined'}
                      sx={{
                        padding: '8px',
                        borderRadius: '16px',
                        gap: '4px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 50,
                        width: '100%',
                        boxShadow: 'unset',
                        color: isSelected ? 'white' : 'black',
                        backgroundColor: isSelected ? '#ec2927' : 'white',
                        borderColor: isSelected ? 'transparent' : '#b3b3b3',
                        py: 1,
                        px: 'auto',
                        '&:hover': {
                          backgroundColor: '#ec2927',
                          color: 'white',
                          borderColor: '#ec2927',
                        },
                        '@media (max-width:407px)': {
                          px: 1.5,
                        },
                        '@media (max-width:383px)': {
                          px: 1,
                        },
                      }}
                    >
                      <Typography className="roboto-sans-regular" fontSize="12px" fontWeight="400 !important">
                        {i === 0 ? 'Tomorrow' : date.format('ddd')}
                      </Typography>
                      <Typography className="roboto-sans-medium" fontSize="14px" fontWeight="500 !important">
                        {date.format('DD-MMM')}
                      </Typography>
                    </Button>
                  </Grid>
                );
              })}
            </Grid>

            {/* <IconButton onClick={handleCalendarClick} sx={{ alignSelf: 'center' }}>
              <CalendarMonthIcon />
            </IconButton> */}
            <Box display="flex" flexDirection="column" alignItems="center" ml="1rem" onClick={handleCalendarClick}>
              <Box
                component="img"
                src="/assets/images/Booking/calendar.png"
                alt="Example"
                sx={{
                  width: 40,
                  height: 40,
                  objectFit: 'cover',
                }}
              />
              <Stack direction="row" spacing={0.5} ml={0.5} alignItems="center">
                <Typography fontSize={11} fontWeight={500}>
                  More
                </Typography>
                <ArrowForwardIosIcon sx={{ fontSize: 10 }} />
              </Stack>
            </Box>
          </Stack>

          <Stack direction={isMobile ? 'column' : 'row'} alignItems={'center'} justifyContent={'space-between'} mt={2}>
            {selectedDate && filteredSessions?.[0] && (
              <Box sx={{ width: '100%' }}>
                {loading ? (
                  <Stack className="slotLoading" sx={{ width: '100%', alignItems: 'center' }}>
                    <CircularProgress color="inherit" size={'50px'} />
                  </Stack>
                ) : (
                  <Stack direction="column" spacing={1} mb={3}>
                    {/* <Typography pb={1} variant="h4" color={'GrayText'} display={'flex'} justifyContent={'center'}>
                      {dayName}, {currentDate}, {currentYear}
                    </Typography> */}
                    {selectedDate && !dates.some((date) => date.isSame(selectedDate, 'day')) && (
                      <Box sx={{ display: 'block', mb: '25px !important' }}>
                        <Chip
                          label={
                            <Typography sx={{ color: 'white', fontWeight: 'bold' }}>
                              <span className="roboto-sans-regular" style={{ fontSize: '13px' }}>
                                {dayName}{' '}
                              </span>
                              {''}
                              <span className="roboto-sans-medium" style={{ fontSize: '14px' }}>
                                {currentDate}
                              </span>
                            </Typography>
                          }
                          onDelete={() => {
                            // setSelectedDate(null);
                            setSelectedDate(moment().add(1, 'day'));
                          }}
                          deleteIcon={<CloseIcon sx={{ marginLeft: 2, fontSize: '16px', color: 'white' }} />}
                          sx={{
                            gap: 1.5,
                            bgcolor: '#ED2629',
                            color: 'white',
                            fontWeight: 'bold',
                            height: 32,
                            width: 'fit-content',
                            '& .MuiChip-deleteIcon': {
                              color: 'white',
                              '&:hover': {
                                color: '#ccc',
                              },
                            },
                          }}
                        />
                      </Box>
                    )}

                    {/* <Typography py={1} variant="subtitle1" className="roboto-sans-medium" fontWeight={500} mb={1}>
                    Time
                  </Typography> */}
                    {/* {filteredSessions?.[0] &&
                    filteredSessions?.[0]?.availableSessions &&
                    !filteredSessions?.[0]?.isHoliday ? ( */}
                    {Array.isArray(filteredSessions?.[0]?.availableSessions) &&
                    filteredSessions[0].availableSessions.length > 0 &&
                    !filteredSessions[0].isHoliday ? (
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '8px',
                        }}
                      >
                        {filteredSessions?.[0]?.availableSessions?.map((item, key) => {
                          const isSelected = item?.session === sessionValue;
                          const isBooked = item?.availableAppoinmentCount <= 0;

                          return (
                            <Button
                              key={key}
                              variant={isSelected ? 'contained' : 'outlined'}
                              onClick={() => {
                                if (!isBooked) {
                                  setSessionValue(item?.session);
                                  setSelectedTimeLabel(item?.timeFrom && item?.timeTo ? `${item.timeFrom} to ${item.timeTo}` : item?.session);
                                  document
                                    .getElementById('scroll')
                                    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                              }}
                              disabled={isBooked}
                              sx={{
                                minWidth: 128,
                                height: 36,
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontSize: '14px',
                                fontWeight: 500,
                                padding: '4px 16px',
                                overflow: 'hidden',
                                backgroundColor: isSelected ? '#ec2927' : '#fff',
                                color: isSelected ? '#fff' : '#000',
                                border: isSelected ? 'none' : '1px solid #c4c4c4',
                                boxShadow: isSelected ? 'none' : '0px 1px 3px rgba(0,0,0,0.1)',
                                position: 'relative',
                                '&:hover': {
                                  backgroundColor: '#ec2927',
                                  color: 'white',
                                  borderColor: '#ec2927',
                                },
                              }}
                            >
                              <span>
                                {item?.timeFrom} to {item?.timeTo}
                              </span>

                              {isBooked && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 6,
                                    right: -13,
                                    transform: 'rotate(45deg)',
                                    backgroundColor: '#999',
                                    color: 'white',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    padding: '1px 12px',
                                    // borderRadius: '12px',
                                    letterSpacing: 1,
                                    pointerEvents: 'none',
                                  }}
                                >
                                  Booked
                                </Box>
                              )}
                            </Button>
                          );
                        })}
                      </Box>
                    ) : (
                      <Typography sx={{ textAlign: 'center' }}>NO AVAILABLE SESSIONS</Typography>
                    )}
                  </Stack>
                )}
              </Box>
            )}
          </Stack>

          <Divider sx={{ mb: '40px', mt: '22px' }} />
          <Stack>
            <form onSubmit={handleSubmit((value, e) => onSubmit(value, e))} noValidate>
              <Grid container spacing={3} mb={2}>
                {/* LEFT SIDE - Name, Email, Phone */}
                <Grid item xs={12} md={6}>
                  <Stack spacing={2}>
                    {/* Name */}
                    <Box>
                      {/* <InputLabel sx={{ color: 'black', fontSize: '14px', pb: 1 }} className="roboto-sans-medium">
                      Name*
                    </InputLabel> */}
                      <TextField
                        id="name"
                        placeholder="Enter Your Name"
                        required
                        size="small"
                        fullWidth
                        type="text"
                        name="name"
                        label="Name"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name', {
                          required: { value: true, message: 'Name is required' },
                        })}
                        sx={{
                          '& label': {
                            color: '#666666', // default label color
                          },
                          '& label.Mui-focused': {
                            color: '#666666', // focused label color
                          },

                          '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                            borderColor: '#666666',
                          },
                        }}
                      />
                    </Box>

                    {/* Email */}
                    <Box>
                      {/* <InputLabel sx={{ color: 'black', fontSize: '14px', pb: 1 }} className="roboto-sans-medium">
                      Email*
                    </InputLabel> */}
                      <TextField
                        id="email"
                        placeholder="Email Address"
                        required
                        size="small"
                        fullWidth
                        label="Email Address"
                        type="email"
                        name="email"
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        {...register('email', {
                          required: { value: true, message: 'Email is required' },
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: 'Enter a valid email address',
                          },
                        })}
                        sx={{
                          '& label': {
                            color: '#666666', // default label color
                          },
                          '& label.Mui-focused': {
                            color: '#666666', // focused label color
                          },

                          '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                            borderColor: '#666666',
                          },
                        }}
                      />
                    </Box>

                    {/* Phone */}
                    <Box>
                      {/* <InputLabel sx={{ color: 'black', fontSize: '14px', pb: 1 }} className="roboto-sans-medium">
                      Phone Number*
                    </InputLabel> */}
                      <TextField
                        id="phone"
                        placeholder="Phone Number"
                        required
                        size="small"
                        fullWidth
                        type="number"
                        label="Phone Number"
                        name="phone"
                        error={!!errors.phone}
                        helperText={errors.phone?.message}
                        {...register('phone', {
                          required: { value: true, message: 'Phone Number is required' },
                          minLength: { value: 9, message: 'At least 9 digits' },
                          maxLength: { value: 15, message: 'No more than 15 digits' },
                        })}
                        sx={{
                          '& label': {
                            color: '#666666', // default label color
                          },
                          '& label.Mui-focused': {
                            color: '#666666', // focused label color
                          },

                          '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                            borderColor: '#666666',
                          },
                        }}
                      />
                    </Box>
                  </Stack>
                </Grid>

                {/* RIGHT SIDE - Address */}
                <Grid item xs={12} md={6}>
                  <Box>
                    {/* <InputLabel sx={{ color: 'black', fontSize: '14px', pb: 1 }} className="roboto-sans-medium">
                    Address*
                  </InputLabel> */}
                    <TextField
                      id="address"
                      placeholder="Your Address"
                      required
                      size="small"
                      fullWidth
                      multiline
                      rows={5}
                      name="address"
                      label="Your Address"
                      error={!!errors.address}
                      helperText={errors.address?.message}
                      {...register('address', {
                        required: { value: true, message: 'Address is required' },
                      })}
                      sx={{
                        '& label': {
                          color: '#666666', // default label color
                        },
                        '& label.Mui-focused': {
                          color: '#666666', // focused label color
                        },

                        '& .MuiInputBase-root': {
                          fontWeight: 'fontWeightRegular',
                          fontSize: '16px',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                          borderColor: '#666666',
                        },
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: '#666666', mt: 1, ml: 1 }}
                      className="roboto-sans-regular"
                    >
                      Flat No, Building Name, (Gate no. Optional)
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              {/* <Grid item xs={12}>
              <InputLabel
                sx={{ paddingBottom: '8px', color: 'black', fontSize: '14px' }}
                className="roboto-sans-medium"
              >
                how many windows do you have?
              </InputLabel>
              <TextField
                id="remarks"
                size="small"
                placeholder="Type here.."
                fullWidth
                multiline
                type="text"
                className="custom-textfield-booking "
                rows={4}
                name="remarks"
                {...register('remarks', {
                  required: { value: false, message: 'Remark is required' },
                })}
                sx={{
                  '& .MuiInputBase-root': {
                    fontSize: '13.5px',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    fontSize: '13.5px',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#666666',
                    },
                  },
                }}
              />
            </Grid> */}
              {/* <Grid item xs={12} sx={{ position: 'relative' }}>
                <Typography py={2} className="roboto-sans-medium" fontSize={14} color="black">
                  Location (Optional)
                </Typography>
                <FormControl fullWidth size="small" sx={{ borderRadius: '12px' }}>
                  <Select
                    displayEmpty
                    id="location"
                    name="location"
                    placeholder="Select Your Location"
                    {...register('location')}
                    defaultValue=""
                    sx={{
                      borderRadius: '12px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ccc',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#666666',
                      },
                    }}
                  >
                    locations
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={12} sx={{ position: 'relative' }}>
                <Typography py={2} mb={6} className="roboto-sans-medium" fontSize={14} color="black">
                  Location (Optional)
                </Typography>
             

                <div>
                  <MyGoogleMap
                    MAP_PUBLIC_KEY={'AIzaSyAU4EsCpVhv88dQYuWU9enLuWLcQ3-Npo8'}
                    markers={markers}
                    setMarkers={setMarkers}
                  />
                </div>
              </Grid>
              <Stack>
                <Typography pt={3} pb={1} className="roboto-sans-medium" mb={1}>
                  <Typography
                    component="span"
                    sx={{ color: 'black', fontWeight: 500, fontSize: '16px', display: 'inline' }}
                  >
                    Select a Payment Method
                  </Typography>{' '}
                  <Box component="span" sx={{ fontSize: '16px', fontWeight: 400, display: 'inline' }}>
                    (To use at checkout)
                  </Box>
                </Typography>

                <RadioGroup
                  row 
                  value={payment}
                  onChange={(e) => setPayment(e.target.value)}
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap', 
                    gap: 2, 
                  }}
                >
                  {methods.map((method) => (
                    <Box
                      key={method.value}
                      sx={{
                        border: payment === method.value ? '2px solid #ec2927' : '1px solid #ccc',
                        borderRadius: '12px',
                        px: 3,
                        py: 1.5,
                       
                        display: 'flex',
                        alignItems: 'center',
                        width: { xs: '100%', sm: 'calc(33.33% - 16px)' },
                      }}
                    >
                      <FormControlLabel
                        value={method.value}
                        control={
                          <Radio
                            sx={{
                              transform: 'scale(0.9)',
                              color: payment === method.value ? '#ec2927' : '#666666',
                              '&.Mui-checked': { color: '#ec2927' },
                            }}
                          />
                        }
                        label={
                          <Box>
                            <Typography className="roboto-sans-medium" sx={{ fontSize: '14px', fontWeight: 400 }}>
                              {method.label}
                            </Typography>
                            {method.miniText && (
                              <Typography className="roboto-sans-medium" sx={{ fontSize: '11px', color: '#888888' }}>
                                {method.miniText}
                              </Typography>
                            )}
                          </Box>
                        }
                        sx={{
                          marginLeft: 0,
                          '& .MuiFormControlLabel-label': {
                            fontSize: '14px',
                          },
                        }}
                      />
                    </Box>
                  ))}
                </RadioGroup>
              </Stack> */}

              <Grid container spacing={2} mt={2}>
                {/* Go Back Button */}
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={() => navigate(-1)}
                    variant="outlined"
                    className="roboto-sans-medium"
                    size="medium"
                    fullWidth
                    sx={{
                      height: '48px',
                      borderRadius: '12px',
                      fontSize: '16px',
                      color: '#ec2927',
                      borderColor: '#ec2927',
                      '&:hover': {
                        backgroundColor: '#fff5f5',
                        borderColor: '#ec2927',
                        fontSize: '17px',
                      },
                    }}
                  >
                    Go Back
                  </Button>
                </Grid>

                {/* Confirm Booking Button */}
                <Grid item xs={12} md={6}>
                  <CustomButton
                    type="submit"
                    variant="contained"
                    className="roboto-sans-medium"
                    size="medium"
                    fullWidth
                    sx={{
                      height: '48px',
                      borderRadius: '12px',
                      fontSize: '16px',
                      backgroundColor: '#ec2927',
                      '&:hover': {
                        backgroundColor: '#d02524',
                      },
                    }}
                  >
                    Confirm Booking
                    {loading && <CircularProgress color="inherit" sx={{ color: 'white', mx: 2 }} size="18px" />}
                  </CustomButton>
                </Grid>
              </Grid>

              {/* <Typography
              pt={2}
              lineHeight="normal"
              textAlign="center"
              className="caveat"
              fontSize="20px"
              color="#666666"
            >
              We’ll be in touch soon to bring the <br /> showroom to your living room.
            </Typography> */}
            </form>
          </Stack>
        </Stack>
        <Popover
          open={openPopover}
          anchorEl={anchorEl}
          onClose={handleCalendarClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          PaperProps={{
            sx: {
              boxShadow: 'none',
              borderRadius: '25px',
            },
          }}
        >
          <Box sx={{ borderRadius: '23px', backgroundColor: 'transparent' }}>
            <Stack
              sx={{
                border: `2px solid ${colors.primary}`,
                borderRadius: '23px',
                width: isMobile ? '250px' : '355px',
                height: isMobile ? '230px' : '352px',
              }}
              className="my-DateCalendar"
            >
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateCalendar
                  sx={{ width: '100%' }}
                  value={selectedDate}
                  onChange={(newValue) => {
                    setSelectedDate(newValue);
                    handleCalendarClose();
                  }}
                  disablePast
                  maxDate={oneWeek}
                  views={['day']}
                  disableHighlightToday
                  shouldDisableDate={(date) => moment(date).isSame(moment(), 'day')}
                />
              </LocalizationProvider>
            </Stack>
          </Box>
        </Popover>
      </Container>
    </Box>
  );
}
